/**
 * İK ekranının metinleri (Ürün Sahibi, 30.08.2026).
 *
 * Desen `ortak.ts` içinde anlatılıyor: ekrana yazılan her cümle burada, kod değerlerinin
 * karşılıkları `ortak.ts` içinde. Bir cümleyi değiştirmek kod değiştirmek olmasın diye.
 */
export const IK_METIN = {
  dizin: {
    ustBaslik: 'İK',
    baslik: 'Çalışan dizini',
    tarif: 'Sistemdeki bütün kullanıcılar: rolü, hesabının durumu ve son girişi.',
    kisiEki: 'kişi',

    araBaslik: 'Ara',
    araIpucu: 'Ad ya da e-posta',
    rolHepsi: 'Bütün roller',
    durumHepsi: 'Etkin ve devre dışı',
    durumEtkinler: 'Yalnız etkin',
    durumPasifler: 'Yalnız devre dışı',

    sutunAd: 'Ad',
    sutunEposta: 'E-posta',
    sutunRol: 'Rol',
    sutunDurum: 'Durum',
    sutunSonGiris: 'Son giriş',
    sutunAcilis: 'Hesap açılışı',

    /** Sıralama düğmesinin ekran okuyucuya okunan adı. */
    siralaEtiketi: (sutun: string) => `${sutun} sütununa göre sırala`,
    artan: 'artan',
    azalan: 'azalan',

    durumEtkin: 'Etkin',
    durumPasif: 'Devre dışı',
    /** Boş bir tarih hücresi "bilgi yok" der; bu kelime "hiç girmedi" der ve ikisi farklı. */
    hicGiris: 'Hiç girmedi',

    ozetBaslik: 'Kadro',
    ozetToplam: 'Toplam',
    ozetEtkin: 'Etkin',
    ozetPasif: 'Devre dışı',
    ozetHicGiris: 'Hiç giriş yapmamış',
    /** Rol dağılımı özetin altında; sayılar süzgeçten etkilenmiyor, kadro kadrodur. */
    ozetRolDagilimi: 'Rol dağılımı',

    /** Tavan aşıldığında: kırpma sessiz olmasın. */
    tavan: (kac: number) => `Kadro ${kac} kişiyi aştı; bu ekran ilk ${kac} kaydı gösteriyor. Sayfalama gerekiyor.`,

    bosBaslik: 'Eşleşen kayıt yok',
    bosTarif: 'Arama kutusunu ya da süzgeçleri gevşetin.',
    hata: 'Çalışan dizini okunamadı.',

    /**
     * Ekranın alt notu. İK'nın bu ekranda **yapamadığı** şeyi söylüyor.
     *
     * Bir kullanıcıyı açmak, rolünü değiştirmek ve kapatmak `/kullanicilar` ekranında ve
     * `user:write` izniyle. Burada o düğmeler yok; olmadıklarını söylemek, aramış olup
     * bulamayan kişiye bir cevap veriyor.
     */
    yetkiNotu:
      'Bu ekran okur, değiştirmez. Hesap açmak, rol atamak ve hesabı kapatmak Kullanıcılar ekranında yapılır.',
  },
} as const;
